export default __webpack_public_path__ + "static/media/trr-event-dance.ccdd5187.png";